import React, { useState } from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { createNewSpace } from "../../firebase/firebase.utils";
import Box from "../retro/box/box.component";
import RetroInput from "../retro/input/input.component";
import RetroButton from "../retro/button/retro-button.component";
import Colors from "../colors/colors.component";
import "./create-space.styles.scss";

export default function CreateSpace({ setLayer }) {
  const currentUser = useSelector(state => state.user.currentUser);
  const [spaceName, setSpaceName] = useState("");
  const [currentColor, setCurrentColor] = useState("#89afb4");
  const [showColors, setShowColors] = useState(false);
  const create = () => {
    if (!spaceName.trim()) return;
    createNewSpace(spaceName.trim(), currentUser, currentColor, setLayer);
  };
  return <motion.div className="createSpace">
    <motion.div className="cs__layer" onClick={() => setLayer(false)} initial={{ opacity: 0 }} animate={{ opacity: 1 }} />
    <motion.div className="cs__content" drag={!showColors} dragConstraints={{ top: -10, left: -10, right: 10, bottom: 10 }} initial={{ y: -36, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
      <Box>
        <h2>Create Workspace</h2>
        <div className="cs__icon">
          <p>Icon Preview</p>
          <RetroButton style={{ background: currentColor }} onClick={() => setShowColors(!showColors)}>{spaceName.charAt(0)}</RetroButton>
          <button type="button" className="cs__color-toggle" onClick={() => setShowColors(!showColors)} aria-expanded={showColors}>Set color</button>
          {showColors && <div className="cs__chooseColor"><Colors columns={6} size={30} defColor={currentColor}
            returnColor={color => { setCurrentColor(color); setShowColors(false); }} /></div>}
        </div>
        <div className="cs__spaceName" onChange={event => setSpaceName(event.target.value)}>
          <RetroInput placeholder="Workspace Name (company name, private, etc.. )" autoFocus />
        </div>
        <div className="cs__createBtn">
          <RetroButton mode="gray" onClick={() => setLayer(false)}>Cancel</RetroButton>
          <RetroButton onClick={create}>Create</RetroButton>
        </div>
      </Box>
    </motion.div>
  </motion.div>;
}
